import styled from '@emotion/styled/macro';

export const ButtonsContainer = styled.section`
    display: flex;
    width: 100%;
    button:nth-of-type(2) {
        margin-left: 16px;
    }
`;

export const Message = styled.section`
    font-size: 20px;
    margin-bottom: 20px;
`;

export const Container = styled.section`
    width: 100%;
    padding: 0 24px 24px 24px;
`;
